import React, { useState } from 'react';
import { Card, CardBody, Button, Input, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Chip, Tabs, Tab, Avatar, Select, SelectItem, Textarea } from '@nextui-org/react';
import HeaderComponent from '../components/General/HeaderComponent';
import { FiPlus, FiSearch, FiHelpCircle, FiEdit2, FiTrash2, FiMessageSquare, FiUser, FiMail, FiClock, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import { Notify } from 'notiflix';

export default function HelpDesk() {
  const [activeTab, setActiveTab] = useState('tickets');
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const [isReplyModalOpen, setIsReplyModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [editingTicket, setEditingTicket] = useState(null);

  // Dummy veriler - Destek talepleri
  const [tickets, setTickets] = useState([
    {
      id: 1,
      ticketNumber: 'TK-2024-001',
      title: 'Giriş yapamıyorum',
      description: 'Hesabıma giriş yaparken şifre hatası alıyorum. Yardımcı olabilir misiniz?',
      requesterName: 'Ahmet Yılmaz',
      requesterEmail: 'ahmet@example.com',
      status: 'open',
      priority: 'high',
      category: 'technical',
      createdAt: '2024-01-15 10:30',
      updatedAt: '2024-01-15 10:30',
      assignedTo: null,
      replies: [
        {
          id: 1,
          author: 'Destek Ekibi',
          message: 'Şifrenizi sıfırlamanız gerekiyor. Şifre sıfırlama linki gönderdim.',
          createdAt: '2024-01-15 11:00'
        }
      ]
    },
    {
      id: 2,
      ticketNumber: 'TK-2024-002',
      title: 'Fatura sorması',
      description: 'Fatura bilgilerimde hata var. Düzeltebilir misiniz?',
      requesterName: 'Ayşe Kaya',
      requesterEmail: 'ayse@example.com',
      status: 'in-progress',
      priority: 'medium',
      category: 'billing',
      createdAt: '2024-01-14 14:20',
      updatedAt: '2024-01-15 09:15',
      assignedTo: 'Mehmet Demir',
      replies: []
    },
    {
      id: 3,
      ticketNumber: 'TK-2024-003',
      title: 'Yeni özellik önerisi',
      description: 'Takvim özelliğine hatırlatıcı eklenebilir mi?',
      requesterName: 'Can Öztürk',
      requesterEmail: 'can@example.com',
      status: 'closed',
      priority: 'low',
      category: 'feature',
      createdAt: '2024-01-12 16:45',
      updatedAt: '2024-01-13 10:00',
      assignedTo: 'Fatma Arslan',
      replies: [
        {
          id: 1,
          author: 'Fatma Arslan',
          message: 'Öneriniz değerlendirilmek üzere ekibimize iletildi. Teşekkürler!',
          createdAt: '2024-01-13 10:00'
        }
      ]
    },
    {
      id: 4,
      ticketNumber: 'TK-2024-004',
      title: 'Ödeme problemi',
      description: 'Kredi kartımdan ödeme alınamadı. Ne yapmalıyım?',
      requesterName: 'Mehmet Demir',
      requesterEmail: 'mehmet@example.com',
      status: 'open',
      priority: 'high',
      category: 'billing',
      createdAt: '2024-01-15 08:00',
      updatedAt: '2024-01-15 08:00',
      assignedTo: null,
      replies: []
    }
  ]);

  const [ticketForm, setTicketForm] = useState({
    title: '',
    description: '',
    category: '',
    priority: 'medium',
    requesterName: '',
    requesterEmail: ''
  });

  const [replyContent, setReplyContent] = useState('');

  const statusOptions = [
    { value: 'all', label: 'Tümü' },
    { value: 'open', label: 'Açık' },
    { value: 'in-progress', label: 'İşlemde' },
    { value: 'closed', label: 'Kapalı' }
  ];

  const priorityOptions = [
    { value: 'low', label: 'Düşük', color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
    { value: 'medium', label: 'Orta', color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300' },
    { value: 'high', label: 'Yüksek', color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300' },
    { value: 'urgent', label: 'Acil', color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300' }
  ];

  const categoryOptions = [
    { value: 'technical', label: 'Teknik' },
    { value: 'billing', label: 'Faturalama' },
    { value: 'feature', label: 'Özellik İsteği' },
    { value: 'bug', label: 'Hata Bildirimi' },
    { value: 'other', label: 'Diğer' }
  ];

  const getStatusLabel = (status) => {
    const labels = {
      open: 'Açık',
      'in-progress': 'İşlemde',
      closed: 'Kapalı'
    };
    return labels[status] || status;
  };

  const getStatusColor = (status) => {
    const colors = {
      open: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
      'in-progress': 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
      closed: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const handleCreateTicket = () => {
    setTicketForm({
      title: '',
      description: '',
      category: '',
      priority: 'medium',
      requesterName: '',
      requesterEmail: ''
    });
    setEditingTicket(null);
    setIsTicketModalOpen(true);
  };

  const handleSaveTicket = () => {
    if (!ticketForm.title || !ticketForm.description || !ticketForm.category || !ticketForm.requesterEmail) {
      Notify.warning('Lütfen zorunlu alanları doldurun');
      return;
    }

    if (editingTicket) {
      setTickets(tickets.map(ticket =>
        ticket.id === editingTicket.id
          ? { ...ticket, ...ticketForm, updatedAt: new Date().toLocaleString('tr-TR') }
          : ticket
      ));
      Notify.success('Talep güncellendi!');
    } else {
      const ticketNumber = `TK-${new Date().getFullYear()}-${String(tickets.length + 1).padStart(3, '0')}`;
      const newTicket = {
        id: tickets.length + 1,
        ticketNumber,
        ...ticketForm,
        status: 'open',
        createdAt: new Date().toLocaleString('tr-TR'),
        updatedAt: new Date().toLocaleString('tr-TR'),
        assignedTo: null,
        replies: []
      };
      setTickets([newTicket, ...tickets]);
      Notify.success('Talep oluşturuldu!');
    }

    setIsTicketModalOpen(false);
    setTicketForm({
      title: '',
      description: '',
      category: '',
      priority: 'medium',
      requesterName: '',
      requesterEmail: ''
    });
    setEditingTicket(null);
  };

  const handleEditTicket = (ticket) => {
    setEditingTicket(ticket);
    setTicketForm({
      title: ticket.title,
      description: ticket.description,
      category: ticket.category,
      priority: ticket.priority,
      requesterName: ticket.requesterName,
      requesterEmail: ticket.requesterEmail
    });
    setIsTicketModalOpen(true);
  };

  const handleDeleteTicket = (ticketId) => {
    setTickets(tickets.filter(ticket => ticket.id !== ticketId));
    if (selectedTicket?.id === ticketId) {
      setSelectedTicket(null);
    }
    Notify.success('Talep silindi');
  };

  const handleUpdateStatus = (ticketId, newStatus) => {
    setTickets(tickets.map(ticket =>
      ticket.id === ticketId
        ? { ...ticket, status: newStatus, updatedAt: new Date().toLocaleString('tr-TR') }
        : ticket
    ));
    Notify.success('Durum güncellendi!');
  };

  const handleReply = () => {
    if (!replyContent.trim() || !selectedTicket) {
      Notify.warning('Lütfen yanıt içeriği girin');
      return;
    }

    const newReply = {
      id: selectedTicket.replies.length + 1,
      author: 'Destek Ekibi',
      message: replyContent,
      createdAt: new Date().toLocaleString('tr-TR')
    };

    setTickets(tickets.map(ticket =>
      ticket.id === selectedTicket.id
        ? {
            ...ticket,
            replies: [...ticket.replies, newReply],
            status: ticket.status === 'open' ? 'in-progress' : ticket.status,
            updatedAt: new Date().toLocaleString('tr-TR')
          }
        : ticket
    ));

    setSelectedTicket({
      ...selectedTicket,
      replies: [...selectedTicket.replies, newReply],
      status: selectedTicket.status === 'open' ? 'in-progress' : selectedTicket.status
    });

    setIsReplyModalOpen(false);
    setReplyContent('');
    Notify.success('Yanıt gönderildi!');
  };

  const filteredTickets = tickets.filter(ticket => {
    const matchesSearch = searchTerm === '' ||
      ticket.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.ticketNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.requesterName.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = filterStatus === 'all' || ticket.status === filterStatus;
    
    return matchesSearch && matchesStatus;
  });

  return (
    <div className="w-full dark:bg-dark-100 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 py-6">
        <HeaderComponent title="Help Desk" />

        <div className="mt-6 space-y-4">
          <div className="flex justify-between items-center">
            <div className="flex gap-4 items-center">
              <Input
                placeholder="Talep ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                startContent={<FiSearch className="text-gray-400" />}
                className="max-w-xs"
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Select
                placeholder="Durum filtresi"
                selectedKeys={filterStatus ? [filterStatus] : []}
                onSelectionChange={(keys) => {
                  const selected = Array.from(keys)[0];
                  setFilterStatus(selected || 'all');
                }}
                className="max-w-xs"
                classNames={{
                  trigger: "border border-gray-200 dark:border-dark-400"
                }}
              >
                {statusOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </Select>
            </div>
            <Button
              className="bg-blue-600 hover:bg-blue-700 text-white"
              startContent={<FiPlus className="w-4 h-4" />}
              onPress={handleCreateTicket}
            >
              Yeni Talep
            </Button>
          </div>

          <div className="grid lg:grid-cols-3 gap-6">
            {/* Sol Kolon - Talep Listesi */}
            <div className="lg:col-span-1">
              <Card className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                <CardBody className="p-0">
                  <div className="divide-y divide-gray-200 dark:divide-dark-400">
                    {filteredTickets.length === 0 ? (
                      <div className="p-8 text-center text-gray-500 dark:text-gray-400">
                        <FiHelpCircle className="w-12 h-12 mx-auto mb-2 opacity-30" />
                        <p>Talep bulunamadı</p>
                      </div>
                    ) : (
                      filteredTickets.map((ticket) => {
                        const priority = priorityOptions.find(p => p.value === ticket.priority);
                        return (
                          <div
                            key={ticket.id}
                            onClick={() => setSelectedTicket(ticket)}
                            className={`p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-dark-400 transition-colors ${
                              selectedTicket?.id === ticket.id ? 'bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-600' : ''
                            }`}
                          >
                            <div className="flex items-start justify-between gap-2 mb-2">
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 mb-1">
                                  <span className="text-xs font-mono text-gray-500 dark:text-gray-400">
                                    {ticket.ticketNumber}
                                  </span>
                                  <Chip
                                    size="sm"
                                    variant="flat"
                                    className={priority?.color}
                                  >
                                    {priority?.label}
                                  </Chip>
                                </div>
                                <h3 className="font-semibold text-[#283252] dark:text-darkWhite-300 mb-1 truncate">
                                  {ticket.title}
                                </h3>
                                <p className="text-xs text-gray-600 dark:text-gray-400 truncate">
                                  {ticket.requesterName}
                                </p>
                              </div>
                              <Chip
                                size="sm"
                                variant="flat"
                                className={getStatusColor(ticket.status)}
                              >
                                {getStatusLabel(ticket.status)}
                              </Chip>
                            </div>
                            <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                              <span className="flex items-center gap-1">
                                <FiClock className="w-3 h-3" />
                                {ticket.createdAt.split(' ')[0]}
                              </span>
                              {ticket.replies.length > 0 && (
                                <span className="flex items-center gap-1">
                                  <FiMessageSquare className="w-3 h-3" />
                                  {ticket.replies.length} yanıt
                                </span>
                              )}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>

            {/* Sağ Kolon - Talep Detay */}
            <div className="lg:col-span-2">
              {selectedTicket ? (
                <Card className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                  <CardBody className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-lg font-mono text-gray-600 dark:text-gray-400">
                            {selectedTicket.ticketNumber}
                          </span>
                          <Chip
                            size="sm"
                            variant="flat"
                            className={getStatusColor(selectedTicket.status)}
                          >
                            {getStatusLabel(selectedTicket.status)}
                          </Chip>
                          <Chip
                            size="sm"
                            variant="flat"
                            className={priorityOptions.find(p => p.value === selectedTicket.priority)?.color}
                          >
                            {priorityOptions.find(p => p.value === selectedTicket.priority)?.label}
                          </Chip>
                        </div>
                        <h2 className="text-xl font-semibold text-[#283252] dark:text-darkWhite-300 mb-2">
                          {selectedTicket.title}
                        </h2>
                      </div>
                      <div className="flex gap-2">
                        <Button
                          size="sm"
                          variant="light"
                          onPress={() => handleEditTicket(selectedTicket)}
                        >
                          <FiEdit2 className="w-4 h-4" />
                        </Button>
                        <Button
                          size="sm"
                          variant="light"
                          className="text-red-400"
                          onPress={() => handleDeleteTicket(selectedTicket.id)}
                        >
                          <FiTrash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>

                    <div className="mb-6">
                      <div className="flex items-center gap-3 mb-4">
                        <Avatar
                          name={selectedTicket.requesterName}
                          size="sm"
                          className="bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"
                        />
                        <div>
                          <p className="font-medium text-[#283252] dark:text-darkWhite-300">
                            {selectedTicket.requesterName}
                          </p>
                          <p className="text-sm text-gray-600 dark:text-gray-400">
                            {selectedTicket.requesterEmail}
                          </p>
                        </div>
                        <span className="text-xs text-gray-500 dark:text-gray-400 ml-auto">
                          {selectedTicket.createdAt}
                        </span>
                      </div>
                      <div className="bg-gray-50 dark:bg-dark-400 rounded-lg p-4 mb-4">
                        <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                          {selectedTicket.description}
                        </p>
                      </div>
                    </div>

                    {/* Yanıtlar */}
                    <div className="mb-6">
                      <h3 className="font-semibold text-[#283252] dark:text-darkWhite-300 mb-3">
                        Yanıtlar ({selectedTicket.replies.length})
                      </h3>
                      <div className="space-y-4">
                        {selectedTicket.replies.length === 0 ? (
                          <p className="text-sm text-gray-500 dark:text-gray-400">Henüz yanıt yok</p>
                        ) : (
                          selectedTicket.replies.map((reply) => (
                            <div key={reply.id} className="flex gap-3">
                              <Avatar
                                name={reply.author}
                                size="sm"
                                className="bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400"
                              />
                              <div className="flex-1">
                                <div className="flex items-center gap-2 mb-1">
                                  <span className="font-medium text-[#283252] dark:text-darkWhite-300">
                                    {reply.author}
                                  </span>
                                  <span className="text-xs text-gray-500 dark:text-gray-400">
                                    {reply.createdAt}
                                  </span>
                                </div>
                                <div className="bg-gray-50 dark:bg-dark-400 rounded-lg p-3">
                                  <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                                    {reply.message}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>

                    {/* Durum Güncelleme ve Yanıt */}
                    <div className="flex gap-2">
                      <Select
                        placeholder="Durum değiştir"
                        selectedKeys={selectedTicket.status ? [selectedTicket.status] : []}
                        onSelectionChange={(keys) => {
                          const selected = Array.from(keys)[0];
                          if (selected) {
                            handleUpdateStatus(selectedTicket.id, selected);
                          }
                        }}
                        className="flex-1"
                        classNames={{
                          trigger: "border border-gray-200 dark:border-dark-400"
                        }}
                      >
                        <SelectItem key="open">Açık</SelectItem>
                        <SelectItem key="in-progress">İşlemde</SelectItem>
                        <SelectItem key="closed">Kapalı</SelectItem>
                      </Select>
                      <Button
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                        startContent={<FiMessageSquare className="w-4 h-4" />}
                        onPress={() => setIsReplyModalOpen(true)}
                      >
                        Yanıtla
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              ) : (
                <Card className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 shadow-none">
                  <CardBody className="p-12">
                    <div className="text-center text-gray-500 dark:text-gray-400">
                      <FiHelpCircle className="w-16 h-16 mx-auto mb-4 opacity-30" />
                      <p>Bir talep seçin</p>
                    </div>
                  </CardBody>
                </Card>
              )}
            </div>
          </div>
        </div>

        {/* Yeni Talep Modal */}
        <Modal isOpen={isTicketModalOpen} onClose={() => setIsTicketModalOpen(false)} size="lg">
          <ModalContent>
            <ModalHeader>{editingTicket ? 'Talep Düzenle' : 'Yeni Destek Talebi'}</ModalHeader>
            <ModalBody>
              <Input
                label="Talep Başlığı"
                placeholder="Sorununuzu kısaca özetleyin"
                value={ticketForm.title}
                onChange={(e) => setTicketForm({ ...ticketForm, title: e.target.value })}
                isRequired
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Textarea
                label="Açıklama"
                placeholder="Sorununuzu detaylı olarak açıklayın"
                value={ticketForm.description}
                onChange={(e) => setTicketForm({ ...ticketForm, description: e.target.value })}
                minRows={4}
                isRequired
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <div className="grid grid-cols-2 gap-4">
                <Select
                  label="Kategori"
                  placeholder="Kategori seçin"
                  selectedKeys={ticketForm.category ? [ticketForm.category] : []}
                  onSelectionChange={(keys) => {
                    const selected = Array.from(keys)[0];
                    setTicketForm({ ...ticketForm, category: selected || '' });
                  }}
                  isRequired
                  classNames={{
                    trigger: "border border-gray-200 dark:border-dark-400"
                  }}
                >
                  {categoryOptions.map((cat) => (
                    <SelectItem key={cat.value} value={cat.value}>
                      {cat.label}
                    </SelectItem>
                  ))}
                </Select>
                <Select
                  label="Öncelik"
                  selectedKeys={ticketForm.priority ? [ticketForm.priority] : []}
                  onSelectionChange={(keys) => {
                    const selected = Array.from(keys)[0];
                    setTicketForm({ ...ticketForm, priority: selected || 'medium' });
                  }}
                  classNames={{
                    trigger: "border border-gray-200 dark:border-dark-400"
                  }}
                >
                  {priorityOptions.map((pri) => (
                    <SelectItem key={pri.value} value={pri.value}>
                      {pri.label}
                    </SelectItem>
                  ))}
                </Select>
              </div>
              <Input
                label="İsim"
                placeholder="Adınız"
                value={ticketForm.requesterName}
                onChange={(e) => setTicketForm({ ...ticketForm, requesterName: e.target.value })}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
              <Input
                label="E-posta"
                placeholder="ornek@example.com"
                type="email"
                value={ticketForm.requesterEmail}
                onChange={(e) => setTicketForm({ ...ticketForm, requesterEmail: e.target.value })}
                isRequired
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsTicketModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleSaveTicket}>
                {editingTicket ? 'Güncelle' : 'Oluştur'}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Yanıt Modal */}
        <Modal isOpen={isReplyModalOpen} onClose={() => setIsReplyModalOpen(false)} size="lg">
          <ModalContent>
            <ModalHeader>Yanıt Yaz</ModalHeader>
            <ModalBody>
              <Textarea
                placeholder="Yanıtınızı yazın..."
                value={replyContent}
                onChange={(e) => setReplyContent(e.target.value)}
                minRows={6}
                classNames={{
                  input: "border border-gray-200 dark:border-dark-400",
                  inputWrapper: "border border-gray-200 dark:border-dark-400"
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button variant="light" onPress={() => setIsReplyModalOpen(false)}>
                İptal
              </Button>
              <Button className="bg-blue-600 text-white" onPress={handleReply}>
                Gönder
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    </div>
  );
}

